<template>
    <div>
        <multiselect
            aria-required="true"
            v-model="selectedOptions"
            :options="localOptions"
            :placeholder="placeholder"
            :multiple="multiple"
            track-by="id"
            label="company_name"
            :custom-label="option => `${option.company_name}`"
        ></multiselect>

        <div v-if="inputName && multiple">
            <input v-for="selectedOption in selectedManagersIds" type="hidden" :name="inputName+'[]'" :value="selectedOption">
        </div>
        <div v-else-if="inputName && ! multiple">
            <input type="hidden" :name="inputName" :value="selectedManagersIds?.length > 0 ? selectedManagersIds[0] : null">
        </div>
    </div>
</template>

<script>
import Multiselect from '../../lib/vue-multiselect/';

export default {
    name: 'CompanySubscriptionMultiSelect',
    components: {
        Multiselect
    },
    props: {
        options: {
            type: Array,
            default: () => [],
        },
        editionId: String,
        communicationLang: String,
        placeholder: String,
        multiple: {
            type: Boolean,
            default: true,
        },
        initialSelectedOptions: {
            type: Array,
            default: () => [],
        },
        inputName: {
            type: String,
            default:  null
        },
    },
    mounted() {
        if (this.options.length > 0) {
            this.localOptions = this.options;
            this.selectInitialOptions();
        } else {
            this.fetchConcernedCompanySubscriptionsForEditionAndLang(this.editionId, this.communicationLang).then(() => {
                this.selectInitialOptions();
            });
        }
    },
    data() {
        return {
            selectedOptions: [],
            localOptions: [],
        }
    },
    computed: {
        selectedManagersIds() {
            if (this.multiple) {
                return this.selectedOptions.map(companySubscription => companySubscription.managers_ids ?? []).flat(1);
            } else {
                return this.selectedOptions.managers_ids ?? [];
            }
        },
        /**
         * Remove the excluded manager users from the recipient users list.
         */
        recipientUsersIds() {
            return this.localOptions
                .filter(companySub => !companySub.managers_ids.every(id => this.selectedManagersIds.includes(id)))
                .map((companySub) => companySub.managers_ids.concat([0])) // A fake id that represent the company email.
                .flat(1)
                .filter(managerUserId => ! this.selectedManagersIds.includes(managerUserId));
        }
    },
    methods: {
        async fetchConcernedCompanySubscriptionsForEditionAndLang(editionId, lang) {
            const response = await axios.get(`/admin/edition/${editionId}/forum/mailing/concerned-companies/${lang}`);
            this.localOptions = response.data;
            return response.data;
        },
        selectInitialOptions() {
            this.selectedOptions = this.localOptions.filter(opt =>
                this.initialSelectedOptions.some(managerUserId => opt.managers_ids.includes(managerUserId))
            );
        },
    },
    watch: {
        communicationLang (lang) {
            this.fetchConcernedCompanySubscriptionsForEditionAndLang(this.editionId, lang).then(() => {
               this.selectedOptions = this.selectedOptions.filter((companySub) =>
                   this.localOptions.some(opt => opt.id === companySub.id)
               );
            });
        },
        selectedOptions () {
            this.$emit('recipients-change', this.recipientUsersIds);
        },
        localOptions () {
            this.$emit('recipients-change', this.recipientUsersIds);
        },
    }
}
</script>

<style>
</style>
